var _path, _path2, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 129,
    viewBox: "0 0 250 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.3335 46.9338H155.667C164.227 46.9338 171.166 53.8636 171.167 62.4104V113.005C171.166 121.552 164.227 128.482 155.667 128.482H94.3335C85.7726 128.482 78.8337 121.552 78.8335 113.005V62.4104C78.8337 53.9972 85.5572 47.1508 93.9331 46.9387L94.3335 46.9338Z",
    stroke: "url(#paint0_linear_280_24959)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155 46.4339V29.2087C155 13.3533 141.569 0.5 125 0.5C108.431 0.5 95 13.3533 95 29.2087V46.4339",
    stroke: "url(#paint1_linear_280_24959)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125,
    cy: 87.7079,
    rx: 9.33333,
    ry: 9.31993,
    fill: "#7DDFBB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_280_24959",
    x1: 125,
    y1: 46.4338,
    x2: 125,
    y2: 128.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B59AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_280_24959",
    x1: 125,
    y1: 0.5,
    x2: 125,
    y2: 46.4339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B59AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71F6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityLockIcon);
export default __webpack_public_path__ + "static/media/security-lock-icon.b1049cadcb1ea768b5937b07e56d2e29.svg";
export { ForwardRef as ReactComponent };